import { STATUS_SUCCESS } from '@/constants/appConstants';
import CampaignService from '@/services/campaignService';

const stateActions = {
  requestCampaigns: ({ commit }) => {
    return CampaignService.getCampaigns().then(response => {
      if (response.status === STATUS_SUCCESS) {
        const campaigns = response.data.sort((bpA, bpB) => {
          return bpA.name > bpB.name ? 1 : -1;
        });

        commit('setCampaigns', campaigns);
      }

      return response;
    });
  }
};

export default {
  ...stateActions
};
